import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const AddCircleIcon = forwardRef<SVGSVGElement, IconProps>(function AddCircleIcon(
  { color = '', height = 12, width = 12, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.60748 4.63661C5.60748 4.40434 5.79577 4.21605 6.02804 4.21605C6.26031 4.21605 6.4486 4.40434 6.4486 4.63661V6.45904H8.27103C8.5033 6.45904 8.69159 6.64733 8.69159 6.8796C8.69159 7.11187 8.5033 7.30016 8.27103 7.30016H6.4486V9.12259C6.4486 9.35486 6.26031 9.54315 6.02804 9.54315C5.79577 9.54315 5.60748 9.35486 5.60748 9.12259V7.30016H3.78505C3.55278 7.30016 3.36449 7.11187 3.36449 6.8796C3.36449 6.64733 3.55278 6.45904 3.78505 6.45904H5.60748V4.63661ZM6 0.851562C2.69904 0.851562 0 3.55061 0 6.85156C0 10.1525 2.69904 12.8516 6 12.8516C9.30096 12.8516 12 10.1525 12 6.85156C12 3.55061 9.30096 0.851562 6 0.851562ZM0.837209 6.85156C0.837209 4.01298 3.16142 1.68877 6 1.68877C8.83858 1.68877 11.1628 4.01298 11.1628 6.85156C11.1628 9.69014 8.83858 12.0144 6 12.0144C3.16142 12.0144 0.837209 9.69014 0.837209 6.85156Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
